import { render } from "./PersonForm.vue?vue&type=template&id=38a499c3&ts=true"
import script from "./PersonForm.vue?vue&type=script&lang=ts"
export * from "./PersonForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kutas.findingyou.co/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__